import { createStore } from "./../store/composed";
export const createSessionStore = (defaultSession, onValidate, namespace = "fs::session") => createStore(defaultSession, namespace, onValidate);
//# sourceMappingURL=index.js.map